import React, { useRef } from 'react';
import { Button, Tooltip } from 'antd';
import { Trans } from 'react-i18next';
import styles from './ChatNotesHeader.module.scss';
import { AiOutlinePlus } from 'react-icons/ai';
import classNames from 'classnames';
const ChatNotesHeader = ({ collapseNotes, toggleCollapseNotes }) => {
    const buttonRef = useRef(null);
    const handleClick = () => {
        toggleCollapseNotes();
        if (buttonRef.current) {
            buttonRef.current.blur();
        }
    };
    return (React.createElement("div", { className: styles.header },
        React.createElement("div", null,
            React.createElement(Trans, { i18nKey: "notes" })),
        React.createElement("div", { className: "close-field-button" },
            React.createElement(Tooltip, { placement: "bottomRight", title: collapseNotes ? 'Open notes' : 'Close notes' },
                React.createElement(Button, { icon: React.createElement(AiOutlinePlus, null), shape: "circle", className: classNames(styles.closeFieldButtonCircle, {
                        [styles.open]: collapseNotes,
                        [styles.closed]: !collapseNotes,
                    }), onClick: handleClick, ref: buttonRef })))));
};
export default ChatNotesHeader;
